import ReactDOM from 'react-dom';
import routes from './routes';
import './styles';

ReactDOM.render(routes, document.getElementById('root'));
